/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

export class QoERegionModeType {
    static ERROR = 'Error';

    static IN = 'In';

    static IN_GRACE_PERIOD = 'InGracePeriod';

    static OUT = 'Out';

    static UNKNOWN = 'Unknown'; // default state
}
